import { SphereIconButton } from "@components/common/sphere-icon-button";
import { neutral, VisibleIcon, NonVisibleIcon } from "@flat-ui";

interface Props {
  /** Whether password is visible or hidden */
  isVisible: boolean;

  /** Callback when button is clicked */
  onClick: () => void;
}

/** Renders the button to show or hide the password input */
export function PasswordInputButton({
  isVisible,
  onClick,
}: Props): JSX.Element {
  return (
    <SphereIconButton
      component={isVisible ? NonVisibleIcon : VisibleIcon}
      onClick={onClick}
      color={neutral[400]}
      buttonSize="24px"
      iconSize="18px"
    />
  );
}
